(function ($, drupalSettings, undefined) {
  'use strict';

  Drupal.behaviors.gallery = {
    attach: function (context, settings) {

      $(once('gallery', '.js-gallery', context)).each(Drupal.behaviors.gallery.init);

      // $('.js-gallery', context).once('gallery').each(Drupal.behaviors.gallery.init);
    },
    init: function(i, element) {
      let $el = $(element);
      let $slider = $('.js-gallery__items', element);

      let config = {
        // Base config for all sliders
        // prevArrow: $el.find('.js-slider__button--prev'),
        // nextArrow: $el.find('.js-slider__button--next'),
        // appendDots: $el.find('.js-slider__dots'),
        dots: false,
        // Gallery slider settings
        adaptiveHeight: true
      };

      // Let's go
      $slider.slick(config);
    }
  };

}(jQuery, drupalSettings));
